<script lang="ts">
	import { enhancedCartStore } from '$lib/stores/enhancedCart.svelte';
	import { onMount } from 'svelte';

	let cartItemCount = $state(0);
	let hasItems = $state(false);

	// Subscribe to cart store updates using derived state
	$effect(() => {
		cartItemCount = enhancedCartStore.itemCount;
		hasItems = cartItemCount > 0;
	});

	// Load cart data on mount - enhanced cart store handles this
	onMount(async () => {
		await enhancedCartStore.loadFromServer();
	});
</script>

{#if hasItems}
	<li id="cart" class="nav-item">
		<a
			href="/cart/review"
			class="cart-header-link has-items"
			title={`You have ${cartItemCount} item${cartItemCount !== 1 ? 's' : ''} in your basket`}
		>
			YOUR BASKET ({cartItemCount})
		</a>
	</li>
{/if}

<style>
	.cart-header-link {
		text-decoration: none;
		color: var(--lg-error) !important;
		text-shadow: var(--lg-shadow-text);
		transition: var(--lg-transition-colors);
	}

	.cart-header-link:hover {
		text-decoration: underline;
	}
</style>
